
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/company_self_solutions_edit",
      function () {
        return require("private-next-pages/companies/company_self_solutions_edit.tsx");
      }
    ]);
  